import React from 'react';

// local dependencies
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { layoutConfig } from 'config/table-configs/claim-detail';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsClaimsEntityWidgetSuccess as MemberDetailsClaimsEntityWidgetSuccess } from 'ui/views/widgets/memberDetailsClaimsEntityWidget';
 *
 * // render
 * <MemberDetailsClaimsEntityWidgetSuccess propName='propValue'/>
 */
const memberDetailsClaimsEntityWidgetSuccess = ( props ) => {

    return (
        <div className='ui-member-details-claims-entity-widget'>

            <TableSearchWidget
                layoutConfig = { layoutConfig }
                templateType = 'inline'
                tableResponse = { props.componentData }
                requestPayload={ props.requestPayload }
                onActionClick={ props.onActionClick }
            />
        </div>
    );
};

// set display name
memberDetailsClaimsEntityWidgetSuccess.displayName = 'memberDetailsClaimsEntityWidget';

// set default props
memberDetailsClaimsEntityWidgetSuccess.defaultProps = {
    requestPayload: {},
};

// prop types
memberDetailsClaimsEntityWidgetSuccess.propTypes = {};

// ***********************************************

/**
 * @type {object}
 * @desc A React presentation/dumb view component preloader.
 * @example
 * import { memberDetailsClaimsEntityWidgetPreloader as MemberDetailsClaimsEntityWidgetPreloader } from 'ui/views/widgets/memberDetailsClaimsEntityWidget';
 *
 * // render
 * <memberDetailsClaimsEntityWidgetPreloader propName='propValue'/>
 */
const memberDetailsClaimsEntityWidgetPreloader = ( ) => {
    return (
        <div className='ui-member-details-claims-entity-widget-preloader'>
            <TableSearchInlineWidgetPreloader
                className='ui-member-details-claims-entity-widget-preloader__table-preloader'
            />
        </div>
    );
};

// set display name
memberDetailsClaimsEntityWidgetPreloader.displayName = 'memberDetailsClaimsEntityWidgetPreloader';

// set default props
memberDetailsClaimsEntityWidgetPreloader.defaultProps = {};

// prop types
memberDetailsClaimsEntityWidgetPreloader.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsClaimsEntityWidget as MemberDetailsClaimsEntityWidget } from 'ui/views/widgets/memberDetailsClaimsEntityWidget';
 *
 * // render
 * <memberDetailsClaimsEntityWidget propName='propValue'/>
 */
export const memberDetailsClaimsEntityWidget = withNetworkState( memberDetailsClaimsEntityWidgetPreloader, memberDetailsClaimsEntityWidgetSuccess );

